import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Área: ")
const _hoisted_2 = { class: "p-fluid" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "position-name" }, "Nombre", -1)
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "position-parent" }, "Área padre", -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { for: "position-assignee" }
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Sub areas", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "h100" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputText, {
            id: "position-name",
            type: "text",
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.name = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Dropdown, {
            id: "position-parent",
            modelValue: _ctx.parent,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.parent = $event)),
            options: _ctx.candidateParents,
            optionLabel: "name",
            filter: true,
            placeholder: "Seleccione un área",
            showClear: true,
            dataKey: "_id"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.membersLabel), 1),
          _withDirectives(_createVNode(_component_Dropdown, {
            id: "position-assignee",
            modelValue: _ctx.assigned,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.assigned = $event)),
            options: _ctx.people,
            optionLabel: "name",
            filter: true,
            placeholder: "Responsable?",
            showClear: true,
            dataKey: "_id",
            onChange: _ctx.assignedChanged
          }, null, 8, ["modelValue", "options", "onChange"]), [
            [_vShow, _ctx.allowSubAreas]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member) => {
              return (_openBlock(), _createElementBlock("div", {
                key: member._id
              }, [
                _createTextVNode(_toDisplayString(member.name) + " ", 1),
                _createVNode(_component_Button, {
                  icon: "pi pi-minus",
                  class: "p-button-rounded p-button-text",
                  onClick: ($event: any) => (_ctx.removeMember(member))
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ], 512), [
            [_vShow, !_ctx.isSingleMember]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.newMember,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newMember = $event)),
              options: _ctx.people,
              optionLabel: "name",
              filter: true,
              placeholder: "Nuevo miembro",
              showClear: true,
              dataKey: "_id",
              onChange: _ctx.addMember
            }, null, 8, ["modelValue", "options", "onChange"])
          ], 512), [
            [_vShow, _ctx.allowManyPeople]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child) => {
            return (_openBlock(), _createElementBlock("div", {
              key: child._id
            }, _toDisplayString(child.name), 1))
          }), 128)),
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.newSubAreaName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newSubAreaName = $event))
          }, null, 8, ["modelValue"])
        ], 512), [
          [_vShow, _ctx.allowSubAreas]
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        icon: "pi pi-trash",
        label: "Remover",
        class: "p-button-sm",
        disabled: !_ctx.canDelete,
        onClick: _ctx.deletePosition
      }, null, 8, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        icon: "pi pi-save",
        label: "Guardar",
        style: {"margin-left":".5em"},
        class: "p-button-sm",
        onClick: _ctx.save
      }, null, 8, ["onClick"])
    ]),
    _: 1
  }))
}